import React from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';

const ThankYouModal = ({ onClose }) => {
    return (
        <Dialog title="Thank You" onClose={onClose}>
            <div style={{ padding: '1rem' }}>
                <p>Thank you for your submission and acknowledgement.</p>
            </div>
            <DialogActionsBar>
                <Button primary={true} onClick={onClose}>
                    Close
                </Button>
            </DialogActionsBar>
        </Dialog>
    );
};

export default ThankYouModal;